export enum BiteLogChaseEvent {
  None = 0,
  TerminalConnected = 1,
  TerminalDisconnected = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  DeviceSetup = 5,
  CloseTransaction = 6,
  CloseTransactionError = 7,
  RefundTransactionRequested = 8,
  RefundTransaction = 9,
  RefundTransactionError = 10,
  Logs = 11,
}
